import { NavLink, useSearchParams } from 'react-router';

import { Divider, Flex, Link, VStack } from '@chakra-ui/react';
import classNames from 'classnames';

import { DefaultToolTip } from '@enterprise/ui';

import type { ReportGridProps } from '@feat/reports/components/types/report-grid.props';

import { useMergePurgeStore } from '@feat/reports/context';

export default function MergePurgeSidebar({ view }: Pick<ReportGridProps, 'view'>) {
  const reports = useMergePurgeStore(({ reports }) => {
    return reports;
  });
  const [searchParams] = useSearchParams();

  return (
    <Flex
      as="nav"
      bg="gray.100"
      borderBottom="1px solid"
      borderBottomColor="gray.500"
      borderRight="1px solid"
      borderRightColor="gray.500"
      color="gray.700"
      direction="column"
      h="full">
      <VStack
        divider={
          <Divider
            borderColor="gray.500"
            m="0!"
          />
        }
        h="full">
        {reports.map(({ name, view: navView }) => {
          const isActive = view.toLowerCase() === navView.toLowerCase();

          return (
            <DefaultToolTip
              key={name}
              label={`View ${name}`}>
              <NavLink
                className={classNames('flex items-center grow w-full px-3 transition-colors', {
                  'bg-hsp-500!': isActive,
                  'text-current!': !isActive,
                  'text-white!': isActive,
                })}
                relative="path"
                to={{ pathname: `../${navView}`, search: searchParams.toString() }}>
                {() => {
                  return (
                    <Link
                      _hover={{ cursor: isActive ? 'default' : 'pointer' }}
                      align="center"
                      as={Flex}
                      fontWeight={600}
                      h="full"
                      isTruncated
                      textDecoration="none"
                      w="full">
                      {name}
                    </Link>
                  );
                }}
              </NavLink>
            </DefaultToolTip>
          );
        })}
      </VStack>
    </Flex>
  );
}
